import { Injectable } from '@angular/core';
import { catchError, Observable, shareReplay, throwError } from 'rxjs';

/**
 * Memoiza as consultas do registro empresarial enquanto a tela existe.
 *
 * Provido no `DealDetailComponent`, e não em root: trocar de etapa destrói o painel do Registro,
 * e voltar a ele não pode reconsultar a Receita; sair da tela, sim, descarta tudo.
 *
 * Erro **não** fica guardado — senão "Tentar de novo" devolveria o mesmo erro para sempre.
 */
@Injectable()
export class CorporateRegistryCacheService {
  private readonly entradas = new Map<string, Observable<unknown>>();

  obter<T>(chave: string, fonte: () => Observable<T>): Observable<T> {
    const existente = this.entradas.get(chave) as Observable<T> | undefined;
    if (existente) {
      return existente;
    }

    const compartilhado = fonte().pipe(
      catchError(erro => {
        this.entradas.delete(chave);
        return throwError(() => erro);
      }),
      shareReplay({ bufferSize: 1, refCount: false })
    );
    this.entradas.set(chave, compartilhado);
    return compartilhado;
  }
}
